<template>
    <div v-if="isVisibleCallAlert && callsData?.length" class="col-xl-3 alert-popup">
        <!-- NEW CODE: iterate and show one popup per call -->
        <div v-for="(call, index) in callsData" :key="index" class="col-xl-3 alert-popup"
            :style="{ top: `${20 + index * 110}px` }">
            <div class="card border-0">
                <div :class="['alert', getAlertClass(call), 'border', getBorderClass(call), 'mb-0', 'p-3']">
                    <div class="d-flex align-items-start">
                        <div class="me-2">
                            <i :class="getIconClass(call)" class="flex-shrink-0"></i>
                        </div>
                        <div :class="getTextClass(call) + ' w-100'">
                            <div class="fw-semibold d-flex justify-content-between">
                                Call Reminder
                                <button type="button" class="btn-close p-0" @click="dismissCallAlert(index)"
                                    aria-label="Close">
                                    <i class="fas fa-xmark"></i>
                                </button>
                            </div>
                            <div class="fs-12 mb-1">
                                {{ call.message }}
                            </div>
                            <div class="fs-12">
                                <a href="javascript:void(0);" :class="getTextClass(call) + ' fw-semibold'"
                                    @click="openAction(call, index)">
                                    open
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div v-if="isVisible && Object.keys(importData)?.length" class="col-xl-3 alert-popup">
        <div class="card border-0">
            <div :class="['alert', alertClass1, 'border', borderClass1, 'mb-0', 'p-3']">
                <div class="d-flex align-items-start">
                    <div class="me-2">
                        <i :class="iconClass1" class="flex-shrink-0"></i>
                    </div>
                    <div :class="textClass1 + ' w-100'">
                        <div class="fw-semibold d-flex justify-content-between">
                            {{ importMessage }}
                            <button type="button" class="btn-close p-0" @click="dismissAlert" aria-label="Close">
                                <i class="fas fa-xmark"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

const props = defineProps({
    callsData: {
        type: Array,
        required: true,
    },
    importData: {
        type: Object,
        required: true,
    }
});

const emit = defineEmits(['dismiss-call-alert']);

const store = useStore();

const token = computed(() => store.getters['auth/authToken']);

const isVisible = ref(true);
const isVisibleCallAlert = ref(true);
const importMessage = ref("");
let alertTimeout = null;
const router = useRouter();

const dismissAlert = () => {
    isVisible.value = false;
};

// const dismissCallAlert = () => {
//     isVisibleCallAlert.value = false;
//     localStorage.setItem('hideCallAlert', Date.now());
// };

const dismissCallAlert = (index) => {
  localStorage.setItem('hideCallAlert', JSON.stringify({ index, timestamp: Date.now() }));
  emit('dismiss-call-alert', index); // dismiss locally
};

// const handleStorageEvent = (event) => {
//     if (event?.key === 'hideCallAlert') {
//         isVisibleCallAlert.value = false;
//         emit('dismiss-call-alert');
//     } else {
//         emit('dismiss-call-alert', index);
//     }
// };

const handleStorageEvent = (event) => {
  if (event.key === 'hideCallAlert' && event.newValue) {
    const data = JSON.parse(event.newValue);
    if (data.index !== null && data.index !== undefined) {
      emit('dismiss-call-alert', data.index); // With index
    } else {
      emit('dismiss-call-alert'); // Without index
    }
  }
};

// const openAction = () => {
//     isVisibleCallAlert.value = false;
//     router.push({
//         path: `/crm/meter-opportunities-edit/${props.callsData[0]?.callDetails?.id}`
//     });
// };

const openAction = (call,index) => {
//   isVisibleCallAlert.value = false;
//   localStorage.setItem('hideCallAlert', Date.now());
emit('dismiss-call-alert', index);
localStorage.setItem('hideCallAlert', JSON.stringify({ index, timestamp: Date.now() }));
  router.push({
    path: `/crm/meter-opportunities-edit/${call.callDetails?.id}`,
  });
};

const startAlertTimer = () => {
    clearTimeout(alertTimeout);
    alertTimeout = setTimeout(() => {
        isVisible.value = false;
    }, 30000);
}

onMounted(() => {
    startAlertTimer();
    // if (localStorage.getItem('hideCallAlert')) {
    //     isVisibleCallAlert.value = false;
    // }
    window.addEventListener('storage', handleStorageEvent);
});

onBeforeUnmount(() => {
    clearTimeout(alertTimeout);
    window.removeEventListener('storage', handleStorageEvent);
});

watch(
    () => props.callsData,
    (newVal) => {
        if (newVal.length) {
            isVisibleCallAlert.value = true;
            // startAlertTimer();
        }
    }
);

watch(
    () => props.importData,
    (newVal) => {
        if (Object.keys(newVal).length) {
            isVisible.value = true;
            startAlertTimer();
        }
    }
);

watch(
    () => token.value,
    (newToken) => {
        if (!newToken) {
            //   isVisible.value = false;
            isVisibleCallAlert.value = false;
            localStorage.setItem('hideCallAlert', Date.now());
        }
    }
);

const minutesUntilCall = computed(() => props.callsData[0]?.minutesUntilCall);

const warning_count = computed(() => props.importData?.warning_count);

// const alertClass = computed(() => {
//     switch (minutesUntilCall.value) {
//         case 30:
//             return 'alert-secondary';
//         case 10:
//             return 'alert-primary';
//         case 2:
//             return 'alert-solid-primary';
//         default:
//             return '';
//     }
// });

// const borderClass = computed(() => {
//     switch (minutesUntilCall.value) {
//         case 30:
//             return 'border-secondary';
//         case 10:
//             return 'border-primary';
//         case 2:
//             return 'border-primary';
//         default:
//             return '';
//     }
// });

// const iconClass = computed(() => {
//     switch (minutesUntilCall.value) {
//         case 30:
//             return 'feather-check-circle';
//         case 10:
//             return 'feather-info';
//         case 2:
//             return 'feather-info';
//         default:
//             return '';
//     }
// });

// const textClass = computed(() => {
//     switch (minutesUntilCall.value) {
//         case 30:
//             return 'text-secondary';
//         case 10:
//             return 'text-primary';
//         case 2:
//             return 'text-fixed-white';
//         default:
//             return '';
//     }
// });

const getAlertClass = (call) => {
    switch (call.minutesUntilCall) {
        case 30: return 'alert-secondary';
        case 10: return 'alert-primary';
        case 2: return 'alert-solid-primary';
        default: return '';
    }
};

const getBorderClass = (call) => {
    switch (call.minutesUntilCall) {
        case 30: return 'border-secondary';
        case 10:
        case 2: return 'border-primary';
        default: return '';
    }
};

const getIconClass = (call) => {
    switch (call.minutesUntilCall) {
        case 30: return 'feather-check-circle';
        case 10:
        case 2: return 'feather-info';
        default: return '';
    }
};

const getTextClass = (call) => {
    switch (call.minutesUntilCall) {
        case 30: return 'text-secondary';
        case 10: return 'text-primary';
        case 2: return 'text-fixed-white';
        default: return '';
    }
};


const alertClass1 = computed(() => {
    if (warning_count.value === 0) {
        importMessage.value = "Success! The file import has been fully processed.";
        return 'alert-success';
    } else {
        importMessage.value = "Success! The file import has been fully processed, but some warnings were encountered. Please review for details.";
        return 'alert-primary';
    }
});

const borderClass1 = computed(() => (warning_count.value === 0 ? 'border-success' : 'border-primary'));

const iconClass1 = computed(() => (warning_count.value === 0 ? 'feather-check-circle' : 'feather-alert-circle'));

const textClass1 = computed(() => (warning_count.value === 0 ? 'text-success' : 'text-primary'));
</script>

<style scoped>
.alert-popup {
    z-index: 99999;
    position: fixed;
    top: 20px;
    right: 20px;
}
</style>
